var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserSingleNeutralMaleCloseGeometricHumanPersonSingleUpUserMale(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 40,
    viewBox: "0 0 38 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user-single-neutral-male--close-geometric-human-person-single-up-user-male"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 25.7143C20.5879 25.7143 22.1602 25.4015 23.6272 24.7939C25.0942 24.1862 26.4271 23.2956 27.5499 22.1728C28.6727 21.05 29.5634 19.7171 30.171 18.2501C30.7787 16.7831 31.0914 15.2107 31.0914 13.6229C31.0914 12.035 30.7787 10.4627 30.171 8.99567C29.5634 7.52867 28.6727 6.19572 27.5499 5.07293C26.4271 3.95014 25.0942 3.05949 23.6272 2.45184C22.1602 1.84419 20.5879 1.53143 19 1.53143C15.7932 1.53143 12.7176 2.80535 10.4501 5.07293C8.18248 7.34051 6.90857 10.416 6.90857 13.6229C6.90857 16.8297 8.18248 19.9052 10.4501 22.1728C12.7176 24.4404 15.7932 25.7143 19 25.7143Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M36.6571 38.5714C35.4577 34.831 33.1014 31.5682 29.928 29.2533C26.7546 26.9384 22.928 25.691 19 25.691C15.072 25.691 11.2454 26.9384 8.07205 29.2533C4.89865 31.5682 2.54235 34.831 1.34286 38.5714H36.6571Z",
    fill: "#D9E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M36.6571 38.5714C35.4577 34.831 33.1014 31.5682 29.928 29.2533C26.7546 26.9384 22.928 25.691 19 25.691C15.072 25.691 11.2454 26.9384 8.07205 29.2533C4.89865 31.5682 2.54235 34.831 1.34286 38.5714H36.6571Z",
    stroke: "#024776",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M19 25.7143C20.5879 25.7143 22.1602 25.4015 23.6272 24.7939C25.0942 24.1862 26.4271 23.2956 27.5499 22.1728C28.6727 21.05 29.5634 19.7171 30.171 18.2501C30.7787 16.7831 31.0914 15.2107 31.0914 13.6229C31.0914 12.035 30.7787 10.4627 30.171 8.99567C29.5634 7.52867 28.6727 6.19572 27.5499 5.07293C26.4271 3.95014 25.0942 3.05949 23.6272 2.45184C22.1602 1.84419 20.5879 1.53143 19 1.53143C15.7932 1.53143 12.7176 2.80535 10.4501 5.07293C8.18248 7.34051 6.90857 10.416 6.90857 13.6229C6.90857 16.8297 8.18248 19.9052 10.4501 22.1728C12.7176 24.4404 15.7932 25.7143 19 25.7143Z",
    stroke: "#024776",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 592",
    d: "M22.9486 18.3C22.9486 18.3 21.9429 20.2743 19 20.2743C16.0571 20.2743 15.0514 18.3029 15.0514 18.3029",
    stroke: "#024776",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect",
    d: "M30.8714 11.32H30.7914C29.1219 11.3216 27.4711 10.9677 25.9489 10.282C24.4267 9.59628 23.0679 8.59436 21.9629 7.34287C20.8575 8.59472 19.4982 9.59685 17.9755 10.2826C16.4528 10.9683 14.8014 11.322 13.1314 11.32C11.1623 11.3241 9.22379 10.8328 7.49429 9.89144C8.32356 7.34288 9.97568 5.14185 12.1913 3.6339C14.4069 2.12594 17.0605 1.39644 19.7356 1.55992C22.4107 1.72339 24.9558 2.77059 26.9713 4.5371C28.9868 6.30362 30.3587 8.68944 30.8714 11.32Z",
    fill: "#D9E4EC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Intersect_2",
    d: "M30.8714 11.32H30.7914C29.1219 11.3216 27.4711 10.9677 25.9489 10.282C24.4267 9.59628 23.0679 8.59436 21.9629 7.34287C20.8575 8.59472 19.4982 9.59685 17.9755 10.2826C16.4528 10.9683 14.8014 11.322 13.1314 11.32C11.1623 11.3241 9.22379 10.8328 7.49429 9.89144C8.32356 7.34288 9.97568 5.14185 12.1913 3.6339C14.4069 2.12594 17.0605 1.39644 19.7356 1.55992C22.4107 1.72339 24.9558 2.77059 26.9713 4.5371C28.9868 6.30362 30.3587 8.68944 30.8714 11.32Z",
    stroke: "#024776",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserSingleNeutralMaleCloseGeometricHumanPersonSingleUpUserMale);
export default __webpack_public_path__ + "static/media/user-single-neutral-male--close-geometric-human-person-single-up-user-male.c0913aac9339e3bece60729c5c34ae29.svg";
export { ForwardRef as ReactComponent };